export default __webpack_public_path__ + "static/avatar-monica-5fb220ad1471ca12021bc877471290ae.png";